import isDev from '../utils/isDev';

export const getSmileyApiUrl = () => {
  return isDev ? 'http://localhost:3000/api/v1' : 'https://buhalbu.com/api/v1';
};
